module.exports = __webpack_public_path__ + "static/media/CorriGolden-resume.0679c88d.pdf";